import { render, staticRenderFns } from "./SurveyStats.vue?vue&type=template&id=25d72dbe&scoped=true&"
import script from "./SurveyStats.vue?vue&type=script&lang=js&"
export * from "./SurveyStats.vue?vue&type=script&lang=js&"
import style0 from "./SurveyStats.vue?vue&type=style&index=0&id=25d72dbe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25d72dbe",
  null
  
)

export default component.exports